import { render } from "./TraktCallback.vue?vue&type=template&id=4900e173&scoped=true"
import script from "./TraktCallback.vue?vue&type=script&lang=js"
export * from "./TraktCallback.vue?vue&type=script&lang=js"

import "./TraktCallback.vue?vue&type=style&index=0&id=4900e173&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4900e173"]])

export default __exports__